// The wide layout: the board and the panel in two columns, on one screen. The
// panel is as tall as the board, so the two make one rectangle.
// The inspector is a tooltip here, so it lives in the board frame.
//
// A match with a wheel: the panel is three blocks, the log, the wheel, and
// the cue at the bottom right. The wheel is against the cue, so the faces of
// the die are beside the die. The log zone holds the history controls in a
// bar at its top, the log, and at its foot the captured pieces and the energy
// of each side. The card of the turn rests on top of the log.
//
// Godsmode: the panel is three sheets, Moon, Sun, and the cue. The log zone
// comes down over the two team sheets while the log is open, and `caster.css`
// has that motion. The cross on its corner or a press outside it closes it. The card of the turn rests at the top of the panel, over the
// sheet of Moon.

import { createCloseButton } from '../components/CloseButton';
import { el } from '../lib/dom';
import { layoutStore } from '../state/layout';
import { closeLog, logOpenStore } from '../state/logOpen';
import type { LayoutParts, MountLayout } from './parts';

/** The button in the top bar opens and closes the log itself, so a press on it is not a press outside. */
const LOG_BUTTON = '.topbar__log';

export const createWideLayout = (parts: LayoutParts): MountLayout => {
  const panel = el('aside', { className: 'panel' });
  const arena = el('div', { className: 'arena' });
  const logZone = el('section', { className: 'log-zone' });
  const closeButton = createCloseButton(closeLog);

  // A press outside the open log closes it. The card of the turn is over the log, and a press on it is a drag.
  document.addEventListener('pointerdown', (event) => {
    if (!logOpenStore.get() || layoutStore.get() !== 'wide') return;
    const target = event.target;
    if (!(target instanceof Element)) return;
    if (logZone.contains(target) || parts.hand.contains(target) || target.closest(LOG_BUTTON))
      return;
    closeLog();
  });

  return (app, mode) => {
    parts.boardFrame.append(parts.inspector);
    if (mode === 'gods') {
      logZone.replaceChildren(parts.historyNav, parts.logBox, parts.graveyard, closeButton);
      // The hand is last, so the card lies over the sheets.
      panel.replaceChildren(logZone, parts.moonTeam, parts.sunTeam, parts.cueBar, parts.hand);
    } else {
      // The hand is last, so the card lies over the log.
      logZone.replaceChildren(
        parts.historyNav,
        parts.logBox,
        parts.graveyard,
        parts.energyRow,
        parts.hand,
      );
      panel.replaceChildren(logZone, parts.wheelBox, parts.cueBar);
    }
    arena.replaceChildren(parts.boardFrame, panel);
    app.replaceChildren(parts.topBar, arena);
  };
};
